function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bolt"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12.189 21.992c-.442 0-1.189-.309-1.189-1.462v-5.53c0-.12-.151-.33-.266-.368l-4.102-1.367c-.543-.181-.958-.577-1.139-1.084-.182-.508-.111-1.076.193-1.56l4.935-7.837c.324-.515.724-.776 1.189-.776.442 0 1.19.308 1.19 1.462v5.53c0 .12.151.33.266.368l4.102 1.367c.543.181.958.577 1.139 1.084.182.508.111 1.076-.193 1.56l-4.935 7.837c-.324.515-.724.776-1.19.776zm-4.664-10.537 3.842 1.28c.931.311 1.633 1.285 1.633 2.265v3.062l3.475-5.516-3.842-1.28c-.931-.312-1.633-1.286-1.633-2.266v-3.062z"
})));

var Svg016Bolt = function Svg016Bolt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg016Bolt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/016-bolt.22383c3f.svg";
export { ForwardRef as ReactComponent };